export default "__VITE_ASSET__DxtBXuMQ__"